import { FunctionComponent } from "react";
import "./PoolPage.scss";
import { Container } from "react-bootstrap";
import PageHeader from "../../components/PageHeader";
import PoolPageDetails from "./PoolPageDetails";
import PoolPageActions from "./PoolPageActions";
import PoolPageAbout from "./PoolPageAbout";

const PoolPage: FunctionComponent<{}> = () => {

    return (
        <>
            <Container fluid className='brand-bgcolor-shadow-black pools-bg'>
                <PageHeader title='Pools' />
                <main className='pool-page-main'>
                    <PoolPageDetails filled={50} />
                    <PoolPageActions />
                    <PoolPageAbout />
                </main>
            </Container>
        </>
    );
};

export default PoolPage;
